import { render, staticRenderFns } from "./Fa.vue?vue&type=template&id=55b4bd5a&scoped=true"
import script from "./Fa.vue?vue&type=script&lang=js"
export * from "./Fa.vue?vue&type=script&lang=js"
import style0 from "./Fa.vue?vue&type=style&index=0&id=55b4bd5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b4bd5a",
  null
  
)

export default component.exports